module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAzElEQVR42u2PvQrCMBRG722aJik2WoiDi5O6qCCI4OzipKsgPoCgrYvPIz6Rz+RHQV1a0GoXaTjD/fk43NCbj4kkMWD63bMs1oE9GJdkoEDbZPGtd+jrk3FbFc9liBqgQIsh6vLenlDnsL2QDcveyNc4OTVu7Gu0GGLVF6qMVxCn2d9D9q5R9xYPnqDFECsEEPtYjeuOxnU8iese0hcYYoUAYoWKZRDlsgrsRrVQ7HScC1YIIFZkIJxQEbX6P9T7ZFIRNL3MKqJW/4X6Dqh/tPx8rmjKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mw.png
// module id = 886
// module chunks = 0